export function getCookie(name) {
  if (typeof document === 'undefined') {
    return undefined;
  }

  const encodedPrefix = `${encodeURIComponent(name)}=`;
  const rawPrefix = `${name}=`;

  const match = document.cookie
    .split(';')
    .map(part => part.trim())
    .find(part => part.startsWith(encodedPrefix) || part.startsWith(rawPrefix));

  if (!match) {
    return undefined;
  }

  const prefix = match.startsWith(encodedPrefix) ? encodedPrefix : rawPrefix;
  const value = match.slice(prefix.length);

  try {
    return decodeURIComponent(value);
  } catch {
    // A malformed percent-encoded value must not throw: callers only need the
    // raw value (e.g. the signal cookie is a presence check).
    return value;
  }
}

export function clearSignalCookie(cookieName) {
  if (typeof document === 'undefined') {
    return;
  }

  const encodedName = encodeURIComponent(cookieName);

  // Clear the host-only cookie (local dev, where the proxy strips the domain).
  document.cookie = `${encodedName}=; Max-Age=0; path=/`;

  // In deployed environments the gateway scopes the signal cookie to the shared
  // root domain (e.g. `.bennie.com`) for cross-app SSO, so a host-only delete
  // alone leaves it in place. Also clear it against the root domain.
  if (typeof window !== 'undefined') {
    const hostParts = window.location.hostname.split('.');
    if (hostParts.length > 1) {
      const rootDomain = `.${hostParts.slice(-2).join('.')}`;
      document.cookie = `${encodedName}=; Max-Age=0; path=/; domain=${rootDomain}`;
    }
  }
}
